<template>
  <div>
    <AlertaPlano
      text="PLANO GRATUITO"
      callbackText="ASSINAR"
      :callback="() => $router.push({ path: '/assinatura/planos' })"
      :plan="true"
      :backButton="true"
      :isGame="false"
    />
    <div class="row d-flex justify-content-center align-items-center" style="height: 55vh">
        <div class="card-share p-4 w-75">
            <h5 class="mb-3">COMPARTILHAR:</h5>
            <div class="row icons justify-content-center">


                <div class="col-md-3 d-flex flex-column justify-content-center align-items-center">
                    <a class=" d-flex flex-column justify-content-center align-items-center" :href="`https://twitter.com/share?url=${link}`" target="_blank">
                        <img src="https://www.flaticon.com/svg/static/icons/svg/124/124021.svg"/>
                        <span class="name">TWITTER</span>
                     </a>
                </div>
                               



                    <!-- <div class="col-md-3  d-flex flex-column justify-content-center align-items-center">
                        <a class=" d-flex flex-column justify-content-center align-items-center" :href="`https://twitter.com/share?url=`" target="_blank">
                            <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/600px-Instagram_icon.png"/>
                            <span class="name">INSTAGRAM</span>
                        </a>
                    </div> -->
                

                <div class="col-md-3  d-flex flex-column justify-content-center align-items-center">
                                                    <a class=" d-flex flex-column justify-content-center align-items-center" :href="`https://api.whatsapp.com/send?text=${link}`" target="_blank">

                    <img src="https://cdn2.iconfinder.com/data/icons/social-messaging-ui-color-shapes-2-free/128/social-whatsapp-circle-512.png"/>
                    <span class="name">WHATSAPP</span>
                                                    </a>
                </div>


                <div class="col-md-3 d-flex flex-column justify-content-center align-items-center">
                <a class=" d-flex flex-column justify-content-center align-items-center" :href="`https://www.facebook.com/sharer/sharer.php?u=${link}`" target="_blank">
                    <img src="https://www.flaticon.com/svg/static/icons/svg/124/124010.svg"/>
                    <span class="name">FACEBOOK</span>
                                                                    </a>

                </div>
            </div>
            <div class=" d-flex justify-content-center align-items-center">
            <div class="row input w-75 mt-4">
                <div class="w-100 relative ">
                    <input id="input" v-model="link" readonly placeholder="link..." class="w-100" />
                <button @click="copy">COPIAR</button>
                </div>
                
            </div>
            </div>
        </div>
    </div>
    
    <AlertaPlano text="VEJA AS NOVIDADES!" />

    <div>
      <SliderBottom />
    </div>
  </div>
</template>

<script>
import AlertaPlano from "../components/AlertaPlano";
import SliderBottom from "../components/SliderBottom"

export default {
  components: {
    AlertaPlano,
    SliderBottom
  },
  name: "Home",
  data: () => ({
    items_slider: [],
    link: ''
  }),
  mounted: async function () {
    this.$store.commit("jogo", false);

    this.link = this.$store.getters.link
  },
  methods: {
      copy(){
        var copyText = document.getElementById("input");
        copyText.select();
        copyText.setSelectionRange(0, 99999); 
        document.execCommand("copy");
      }
  },
};
</script>
<style scoped>
.card-share{
    border: none;
    background: white;
    box-shadow: 10px 10px 30px rgba(0, 0, 0, 0.041);
    letter-spacing: 2px;
}

.icons img{
    width: 50px;
}


a{
    text-decoration: none;
    color: black;
}

a:hover{
    text-decoration: none;
    color: black;
}

.input input{
    height: 40px;
    padding-left: 10px;
    text-transform: uppercase;
    border: none;
    outline: 0;
    background-color: rgb(233, 233, 233);
}

.input button{
    position: absolute;
    right: 10px;
    height: 25px;
    top: calc(50% - 12.5px);
    border: none;
    padding: 0px 10px;
    font-size: 15px;
    outline: 0;
    color: white;
    background-color: #8d4d9a;
}


.input{
    position: relative;
   
}

.name{
    margin-top: 10px;
}


.btn-next {
  position: absolute;
  top: calc(50% - 15px);
  right: 20px;
  color: black;
  font-size: 30px;
  color: black;
  outline: 0;
  z-index: 9999;
  border: none;
}

.btn-prev {
  position: absolute;
  top: calc(50% - 15px);
  left: 20px;
  color: black;
  font-size: 30px;
  z-index: 99999;
  color: black;
  outline: 0;
  border: none;
}
</style>
